import React from 'react';
import classes from './StaticPages.module.css';

const privacy = () => {
  return (
    <div className={classes.ContentContainer}>
      <h2 className={classes.Centered}>RIZA PRIVACY POLICY</h2>
      <p className={classes.Centered}>Effective Date: March 19, 2021</p>
      <p>
        Strength-Based Family Systems, LLC (“Company”, “we”, “our”, or “us”) is the company that created Riza. We designed Riza to be a safe space
        where people can improve their lives and share the whole of their lives with each other, strengthening and deepening their relationships. Riza
        helps you, your family and your community tell the story of your life together. This story naturally will include personal and important
        information, and for that reason we work hard to make Riza a safe and secure environment that allows you to feel comfortable both as
        individuals and as groups. It is important to us that you can trust Riza as a place where your information is safe and secure. We are
        committed to earning your trust. One of the ways we can do that is to be clear to you about how Riza works.
      </p>
      <p>
        This Privacy Policy applies to our mobile app for iOs and our web-based app found at www.beta.riza.life. This Privacy Policy explains how your
        personal information is collected, used and disclosed by Riza (also referred to in this policy document as our “Service” or “Riza”). By
        accessing or using our Service, you signify that you have read, understood and agree to our collection, storage, use and disclosure of your
        personal information as described in this Privacy Policy.
      </p>
      <p className={classes.Bold}>1. WHAT INFORMATION DO WE COLLECT AND FOR WHAT PURPOSE?</p>
      <p>The categories of information we collect can include:</p>
      <ul>
        <li>
          <strong>Information you provide to us directly.</strong> We may collect personal information, such as your name, date of birth, phone
          number, location, and e-mail address when you register for Riza, sign up for our mailing list, or otherwise communicate with us. We may also
          collect any communications between you and Riza and any other information you provide to us.
        </li>
        <li>
          <strong>Data collected through the use of Riza.</strong> We collect information about how you use our Services, your actions on Riza, and
          content you post to Riza, including the groups you belong to, your interaction with others on the Service, photos and videos you post to our
          Service, and any content you provide on posts, contributions, or r other functionality ("User Content"). To share photos and video, we will
          access your device camera roll and camera with your permission. If you wish to change these permissions, you can do so in the "Settings" app
          of your device. Please remember that Riza may, but has no obligation to, monitor, record, and store User Content in order to protect your
          safety or the safety of other users, to assist with regulatory or law enforcement efforts, or to protect and defend our rights and property.
          By using our Service, you consent to the recording, storage and disclosure of such communications you send or receive for these purposes.
        </li>
        <li>
          <strong>Address Book Information.</strong> With your permission, we may access your contact list available on your mobile device or in your
          email accounts in order to locate your contacts on Riza and to invite your friends and family to connect with Riza. When we invite your
          contacts to join Riza, we will include your name and photo to let them know that you are the person extending the invitation. After sending
          these invitations, we may also send reminder emails to your invitees on your behalf, which may also include your name and photo. We will
          store these contacts for purposes of alerting you when your contacts join Riza at a later time so that you may connect with them on our
          Service, and to suggest friends and connections to other members of the Service.
        </li>
        <li>
          <strong>Location Information.</strong> We collect your unique user identifier and your location through GPS, WiFi, or wireless network
          triangulation in order to obtain your location for the purposes of providing our Service to you. We maintain location information only so
          long as is reasonable to provide our Service. We may maintain de-identified location data for a longer period of time in order to analyze
          aggregate trends and metrics. If you want to opt-out of the collection of your location data, please adjust your settings in your mobile
          device to limit the Service’s access to your location data. Please see “Control Over Your Information” below to learn more.
        </li>
      </ul>
      <p>
        We use this information to operate, maintain, and provide to you Riza’s features and functionality, as well as to communicate directly with
        you, such as to send you email messages and push notifications, and permit you to communicate with others on Riza or invite others to join
        Riza. We may also send you Riza-related emails or messages (e.g., account verification, change or updates to features of Riza, technical and
        security notices). For more information about your communication preferences, see “Control Over Your Information” below.
      </p>
      <p>
        The Service is directed to users located in the United States. If you are located outside of the United States and choose to use Riza or
        provide your information to us, you should be aware that we may transfer your information to the United States and process it there. The
        privacy laws in the United States may not be as protective as those in your jurisdiction.{' '}
        <strong>
          Your consent to this privacy policy followed by your submission of information to us through or in connection with Riza represents your
          agreement to the transfer of your information to the United States.”
        </strong>
      </p>
      <h3>2. HOW WE USE COOKIES AND OTHER TRACKING TECHNOLOGY TO COLLECT INFORMATION.</h3>
      <p>
        We, and our third party partners, automatically collect certain types of usage information when you use Riza, read our emails, or otherwise
        engage with us. We typically collect this information through a variety of tracking technologies, including cookies, web beacons, file
        information and similar technology (collectively, “tracking technologies”).
      </p>
      <p>
        For example, we collect information about your device and its software, such as your IP address, browser type, Internet service provider,
        platform type, device type, operating system, date and time stamp, a unique ID that allows us to uniquely identify your browser, mobile device
        or your account, and other such information. When you access our Service from a mobile device, we may collect unique identification numbers
        associated with your device or our mobile application, mobile carrier, device type, model and manufacturer, mobile device operating system
        brand and model, phone number, and depending on your mobile device settings, your geographical location data, including GPS coordinates (e.g.,
        latitude and/or longitude) or similar information regarding the location of your mobile device, or we may be able to approximate a device’s
        location by analyzing other information, like an IP address.
      </p>
      <p>
        We may collect analytics data, or use third-party analytics tools, to help us measure traffic and usage trends for Riza and to understand more
        about the demographics of our users. Although we do our best to honor the privacy preferences of our users, we are unable to respond to Do Not
        Track signals set by your browser at this time. However, the Do Not Track signal was largely intended to indicate a preference not to be
        tracked for third-party behavioral advertising or market purposes. We do not track your behavior for third-party behavioral advertising or
        marketing purposes. Rather, we track your online behavior merely for our own purposes as explained in the next paragraph.
      </p>
      <p>
        We use or may use the data collected through tracking technologies to: (a) remember information so that you will not have to re-enter it
        during your visit or the next time you use Riza; (b) provide and monitor the effectiveness of Riza; (c) monitor aggregate metrics such as
        total number of visitors, traffic, usage, and demographic patterns on Riza; (d) diagnose or fix technology problems; and (e) otherwise to plan
        for and enhance Riza.
      </p>
      <p>
        To the extent you access Riza using a web browser, if you would prefer not to accept cookies, most browsers will allow you to: (i) change your
        browser settings to notify you when you receive a cookie, which lets you choose whether or not to accept it; (ii) disable existing cookies; or
        (iii) set your browser to automatically reject cookies. Please note that doing so may negatively impact your experience using Riza, as some
        features and services on our Service may not work properly. Depending on your mobile device and operating system, you may not be able to
        delete or block all cookies. You may also be able to configure your e-mail reader to prevent the automatic downloading of images that may
        contain technologies that would allow us to know whether you have accessed our e-mail and performed certain functions with it.
      </p>
      <h3>3. SHARING OF YOUR INFORMATION</h3>
      <p>
        We may share your personal information in the instances described below. For further information on your choices regarding your information,
        see the “Control Over Your Information” section below.
      </p>
      <p>We may share your personal information with: </p>
      <ul>
        <li>
          Our Service Providers. We may provide personal information about you to service providers that perform certain functions or services on our
          behalf (for example, hosting our Service, storing our data, managing databases, performing analyses, collecting location data, providing
          location-based services, providing customer service, or sending communications for us). These companies are contractually limited in the
          ways in which they may use this personal information.
        </li>
        <li>
          Other parties in connection with a company transaction, such as a merger, sale of company assets or shares, reorganization, financing,
          change of control or acquisition of all or a portion of our business by another company or third party, or in the event of a bankruptcy or
          related or similar proceedings.
        </li>
        <li>
          Third Party Analytics Providers. We may share your information and personal information with our advertising and analytics partners, such as
          Google Analytics. The privacy policy of these third party companies applies to their collection, use and disclosure of your information.
          These third parties may combine your information with the information of other consumers for purposes of conducting these studies and/or
          analytics. You can review the Google Analytics privacy policy by visiting this link:{' '}
          <a href="https://support.google.com/analytics/answer/6004245?hl=en">https://support.google.com/analytics/answer/6004245?hl=en</a>.
        </li>
        <li>
          Third parties as required by law or subpoena or if we reasonably believe that such action is necessary to (a) comply with the law and the
          reasonable requests of law enforcement; (b) to protect the security or integrity of Riza; and/or (c) to exercise or protect the rights,
          property, or personal safety of Company, our visitors, or others.
        </li>
      </ul>
      <p>
        We may also share information with others in an aggregated or otherwise anonymized form that does not reasonably identify you directly as an
        individual.
      </p>
      <h3>4. CONTROL OVER YOUR INFORMATION</h3>
      <p>
        <strong>Profile and Data Sharing Settings. </strong> You may update your profile information, such as your user name and profile photo, and
        may change some of your data sharing preferences on your Settings page or by emailing us at hello@riza.life.
      </p>
      <p>
        <strong>Access to your Device Information. </strong> You may control the Service’s access to your device information through your “Settings”
        app on your device. For instance, you can withdraw permission for the Service to access your address book, location, photo stream and camera.
      </p>
      <p>
        <strong>How to control your communications preferences. </strong> You can stop receiving promotional email communications from us by clicking
        on the “unsubscribe link” provided in such communications. We make every effort to promptly process all unsubscribe requests. You may not opt
        out of service-related communications (e.g., account verification, transactional communications, changes/updates to features of the Service,
        technical and security notices).
      </p>
      <p>
        <strong>Modifying or deleting your information. </strong>If you have any questions about reviewing, modifying, or deleting your information,
        you can contact us directly at hello@riza.life. We may not be able to modify or delete your information in all circumstances.
      </p>

      <h3>5. HOW WE PROTECT YOUR INFORMATION</h3>
      <p>
        We care about the security of your information and use commercially reasonable physical, administrative, and technical safeguards to preserve
        the confidentiality, integrity, and availability of all information collected through Riza. However, no security system is impenetrable and we
        cannot guarantee the security of our systems. In the event that any information under our control is compromised as a result of a breach of
        security, we will take reasonable steps to investigate the situation and, where appropriate, notify those individuals whose information may
        have been compromised and take other steps, in accordance with any applicable laws and regulations.
      </p>
      <h3>6. CHILDREN’S PRIVACY</h3>
      <p>
        The&nbsp;Children's&nbsp;Online&nbsp;Privacy&nbsp;Protection&nbsp;Act&nbsp;of 1998 and its rules (collectively, "COPPA") require us to inform
        parents and legal guardians (as used in this section, "parents") about our practices for collecting, using, and disclosing personal
        information from children under the age of 13 (“child” or "children"). It also requires us to obtain verifiable consent from a child's parent
        for certain collection, use, and disclosure of the child's personal information.
      </p>
      <p>
        Below we summarize potential instances of collection and outline how and when we will provide parental notice and/or seek parental consent. In
        any instance that we collect personal information from a child, we will retain that information only so long as reasonably necessary to
        fulfill the activity request or allow the child to continue to participate in the activity, and ensure the security of our users and our
        services, or as required by law. In the event we discover we have collected information from a child in a manner inconsistent with COPPA’s
        requirements, we will either delete the information or immediately seek the parent’s consent for that collection.
      </p>
      <p>
        This section only applies to the usage of our Services by children under the age of 13 and supplements the other provisions of this privacy
        policy.
      </p>
      <h4>Registration and Consent</h4>

      <p>
        There are three ways children can participate in Riza: 1) a parent can add a child’s profile and maintain full administrative authority for
        the child until age 13; 2) a parent can provide consent for another adult to add their child’s profile and maintain full administrative
        authority for the child until age 13; 3) a parent or another adult with parental consent can add a child’s profile and then email-invite a
        child to establish his or her own account. A child under the age of 13 is not allowed to register or add any personal content until one of
        those options occurs. This policy is intended so that a child may not sign up for Riza without the parent’s full knowledge and consent. By you
        allowing a child to participate in Riza, you acknowledge and consent to the data collection practices explained in this section.
      </p>

      <h4>Information We Collect from Children</h4>
      <p>
        Children can access many parts of the Service and its content and use many of its features without providing us with personal information.
        However, some content and features require us to collect certain information, including personal information, from them. In addition, we use
        certain technologies, such as cookies, to automatically collect information from our users (including children) when they visit or use the
        Service.
      </p>
      <p>
        We only collect as much information about a child as is reasonably necessary for the child to participate in an activity, and we do not
        condition his or her participation on the disclosure of more personal information than is reasonably necessary.
      </p>

      <h4>Information We Collect Directly</h4>
      <p>
        A parent must provide us with the following information to register a child with Riza: the child's first name, birth date and a parent's email
        address. We also require the child to have a member name and password. We may request additional information from your child, but this
        information is optional. We specify whether information is required or optional when we request it.
      </p>
      <p>
        We use the personal information we collect from your child to register him or her with Riza and communicate with him or her about activities
        or features of Riza that may be of interest.
      </p>
      <p>
        We enable registered users to communicate with others on or through Riza. The nature of these features allows children to disclose personal
        information about themselves. We do not monitor or review this content before it is posted, and we do not control the actions of third parties
        with whom your child shares his or her information. We encourage parents to educate their children about safe internet use and to monitor
        their children's use of shared content.
      </p>
      <h4>Automatic Information Collection and Tracking</h4>
      <p>
        When children interact with us, certain information may automatically be collected, both to make Riza more interesting and useful to children
        and for various purposes related to our business. Examples include the type of computer operating system, the child’s IP address or mobile
        device identifier, the web browser, the frequency with which the child visits various parts of our Service, and information regarding the
        online or mobile service provider. This information is collected using technologies such as cookies, web beacons, and other unique identifiers
        (as further explained in Section 2). This information may be collected by Riza or by a third party. This data is principally used for internal
        purposes only, in order to:
      </p>
      <ul>
        <li>Provide children with access to features and activities on Riza.</li>
        <li>Customize content and improve Riza.</li>
        <li>Conduct research and analysis to address the performance of Riza.</li>
        <li>
          In the event we collect (or allow others to collect) such information from children on Riza for other purposes, we will notify parents and
          obtain consent prior to such collection.
        </li>
      </ul>
      <h4>Our Practices for Disclosing Children’s Information</h4>
      <p>We do not share, sell, rent, or transfer children's personal information other than as described in this section.</p>
      <p>
        We may disclose aggregated information about many of our users, and information that does not identify any individual. In addition, we may
        disclose children's personal information:
      </p>
      <ul>
        <li>
          To third parties we use to support the internal operations of Riza and who are bound by contractual or other obligations to use the
          information only for such purpose and to keep the information confidential.
        </li>
        <li>
          If we are required to do so by law or legal process, such as to comply with any court order or subpoena or to respond to any government or
          regulatory request.
        </li>
        <li>
          If we believe disclosure is necessary or appropriate to protect the rights, property, or safety of Strength-Based Family Systems, our users
          or others, including to protect the safety of a child, protect the safety and security of Riza, or enable us to take precautions against
          liability.
        </li>
        <li>To law enforcement agencies or for an investigation related to public safety.</li>
      </ul>

      <p>
        Social Features: The Service offers social features, including the ability to share posts of content and contributions that enable children to
        communicate with others on or through Riza. We do not control the types of information your child can send or post through them. We encourage
        parents to educate their children about safety online and to carefully monitor their children's use of social features to ensure they do not
        disclose their personal information through them.
      </p>

      <h4>Additional Parental Consent </h4>
      <p>
        In the event Company wishes to share a child’s personal information with a third party, such as sharing personal information for social
        research purposes, Company will seek additional parental consent. In seeking such consent, we will explain what information we are collecting,
        how we plan to use it, how the parent can provide consent, and how the parent can revoke consent.
      </p>
      <h4>Accessing and Correcting Your Child's Personal Information</h4>
      <p>
        At any time, you may review the child's personal information maintained by us, require us to correct or delete the personal information,
        and/or refuse to permit us from further collecting or using the child's information.
      </p>
      <p>You can review, change, or delete your child's personal information by:</p>
      <ul>
        <li>Logging into your child's account and visiting his or her account profile page.</li>
        <li>
          Sending us an email at hello@riza.life. To protect your privacy and security, we may require you to take certain steps or provide additional
          information to verify your identity before we provide any information or make corrections.
        </li>
      </ul>
      <h3>7. LINKS TO OTHER WEB SITES AND SERVICES</h3>

      <p>
        The Service may contain links to and from third party websites of our business partners and our users may post links to third party websites.
        If you follow a link to any of these websites, please note that these websites have their own privacy policies and that we do not accept any
        responsibility or liability for their policies. We strongly recommend that you read their privacy policies and terms and conditions of use to
        understand how they collect, use, and share information. We are not responsible for the privacy practices or the content on the websites of
        third party sites.
      </p>

      <h3>8. HOW TO CONTACT US</h3>
      <p>If you have any questions about this Privacy Policy or the Service, please contact us at hello@riza.life.</p>
      <h3>9. CHANGES TO OUR PRIVACY POLICY</h3>
      <p>
        We may modify or update this Privacy Policy from time to time to reflect the changes in our business and practices, and so you should review
        this page periodically. When we change the policy in a material manner we will let you know and update the “last modified” date at the top of
        this page. If you object to any changes, you may close your account. Continuing to use our Service after we publish changes to this Privacy
        Policy means that you are consenting to the changes.
      </p>
    </div>
  );
};

export default privacy;
